import React, { useCallback, useState } from 'react';
import { ToastSeverity } from './constant';
import ToastComponent from './toast.component';
import ToastContext from './toast.context';

const ToastContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [message, setMessage] = useState<string | React.ReactNode>('');
  const [severity, setSeverity] = useState<ToastSeverity>(ToastSeverity.info);
  const [open, setOpen] = useState<boolean>(false);
  const [autoHideDuration, setAutoHideDuration] = useState<number | undefined>(
    undefined,
  );
  const [description, setDescription] = useState<string>('');

  const handleClose = () => {
    setOpen(false);
  };

  const openToast = useCallback(
    ({
      message,
      severity = ToastSeverity.info,
      autoHideDuration,
      description = '',
    }: {
      message: string | React.ReactNode;
      severity?: ToastSeverity;
      autoHideDuration?: number;
      description?: string;
    }) => {
      setMessage(message);
      setSeverity(severity);
      setAutoHideDuration(autoHideDuration);
      setDescription(description);
      setOpen(true);
    },
    [],
  );

  return (
    <ToastContext.Provider value={{ openToast }}>
      {children}
      <ToastComponent
        message={message}
        severity={severity}
        visibility={open}
        handleToastClose={handleClose}
        autoHideDuration={autoHideDuration}
        description={description}
      />
    </ToastContext.Provider>
  );
};

export default ToastContextProvider;
